<template>
  <section id="about">
    <div class="hero-image">
      <img src="../../static/static-css/img/about-us/about.jpg" alt />
      <div class="overlay"></div>
    </div>
    <div class="dasboard-content">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="tittle">
              <h3>About US</h3>
            </div>
            <div class="content">
              <p>
                Our Financial Statements Translation Tool ("FSTT") was developed to provide an instant and cost-effective translation financial statements belonging to corporate entities based in the Russian Federation.
              </p>
              <p>
                The main benefit for companies using FSTT is the ease with which a set of financials is translated. The user does not need to have any ability in Russian language.
              </p>
              <p>
                While IFRS and GAAP adjustments are not made, key numbers are presented in an internationally recognized format, which facilitates quick review and decision-making. And it costs less than a cup of fancy coffee!
              </p>
            </div>
            <div class="tittle mt-5">
              <h3>Our Vision</h3>
            </div>
            <div class="content">
              <p>
              To help small and midsize enterprises prosper by providing cost-effective and efficient translation of standard Russian Federation financial statements
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  created () {
    this.$store.commit('ISLOADING', false)
  }
}
</script>

<style>

.hero-image {
  position: relative;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background-color: rgba(0,0,0,0.5);
}

.hero-image img {
  max-height: 500px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue